module.exports = __webpack_public_path__ + "img/pdtqk.12c1a8d5.png";